import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element)
      .select2({
        width: "100%",
        allowClear: true,
        placeholder: this.element.dataset.placeholder || "",
      })
      .on("select2:select select2:unselect select2:clear", () => {
        this.element.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }
}
